import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../../store/root-reducer';

import IcpForBusinessStep from './icp-for-business-step';

interface IcpForBusinessStepContainerProps {
  handleMoveToNextStep: () => void;
  saveCurrentStepDetails?: (payload: any) => void;
}

const IcpForBusinessStepContainer: React.FC<IcpForBusinessStepContainerProps> = ({
  saveCurrentStepDetails,
}) => {
  const {
    data,
    data: { idealCustomerProfiles },
  } = useSelector((state: RootState) => state?.sequence?.generateAiSeqModal);

  return (
    <IcpForBusinessStep
      idealCustomerProfiles={idealCustomerProfiles}
      aiSeqUserData={data}
      saveCurrentStepDetails={saveCurrentStepDetails}
    />
  );
};

export default memo(IcpForBusinessStepContainer);
